// **************************************************
// Audio button
// **************************************************

const playerBtn = document.querySelector('.player__btn');

playerBtn?.addEventListener('click', () => {
  playerBtn.classList.toggle('is-paused');
});
